import React, { Component } from 'react';
import moment from 'moment';
import Loading from '../../ui/Loading';
import { handleCookieNav } from '../../ui/CookieLink';

const REACT_APP_CHECKOUT_LINK = `${process.env.REACT_APP_CHECKOUT_LINK}`;

const iviteSentMessage = ({ClubName, deletedProfile}) =>{
  if(deletedProfile){
    return (
      `Our records indicate you were previously a member of Twomey. If you wish to re-join, please contact us at (707) 942-7111.`
    );
  }
  return (
    `You have been invited to join the ${ClubName} membership. Use the accept invite
    button below to become a member.`
  );
};

const inviteButtonDisplay = ({hasClubMembershipInCart, acceptInvitationInProgress, WaitlistId, waitlist, acceptInvitation, IsDisabled}) =>{

  //dont display button if the user has a previous account
  if(IsDisabled){
    return(<span></span>)
  }

  if(hasClubMembershipInCart){
    return (
      <a href="#"
        className="btn btn-primary"
      >
        {`Membership in cart`}
      </a>
    )
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'row' }}>
      <a href="#"
        className="btn btn-primary"
        style={{ marginRight: '1rem' }}
        onClick={() => {
          if (acceptInvitationInProgress) return;
          //showModal('ClubPaymentModal')
          const payload = {
            waitListId: WaitlistId,
            clubTypeId: waitlist,
          }
          acceptInvitation(payload, null, null, (result) => {
            const { success } = result;
            if (success) {
              handleCookieNav(`${REACT_APP_CHECKOUT_LINK}/shipping`, 'clubJoin=true')
            }
          });
        }}
      >
        {`accept invite`}
      </a>
      {acceptInvitationInProgress && <Loading small />}
    </div>
  )
};

class NotActive extends Component {
  constructor(props) {
    super(props);
    this.state = { loadedClubInfo: false }
  }

  render() {
    const {
      user,
      clubResult,
      clubByIdInProgress,
      clubError,
      showModal,
      joinWaitListResult,
      waitListStatusInProgress,
      waitlist,
      acceptInvitationResult,
      acceptInvitation,
      cartResult,
      acceptInvitationInProgress,
      validateLoginInProgress
    } = this.props;

    const {
      ClubName,
      inWaitList,
      waitList,
      existingWaitList,
      IsDisabled
    } = clubResult || {};

    const {
      waitListClubName,
      InviteSentDate,
      expired,
      WaitlistId
    } = waitList || {};

    const { shoppingCartItems = [] } = cartResult || {};
    const hasClubMembershipInCart = acceptInvitationResult ||
      shoppingCartItems.some(({ clubContinuityTypeId }) => clubContinuityTypeId > 0)

    return (
      <div className="col-products club-info">
        {
          (
            waitListStatusInProgress ||
            ClubName
          ) ?
            <>
              {(clubByIdInProgress ||
                waitListStatusInProgress ||
                !user
              ) ?
                <Loading /> :
                <>
                  {
                    clubError ?
                      <p className="account-info-block">
                        {clubError.message || ''}
                      </p>
                      :
                      <>
                        <p className="account-info-block">
                          {
                            joinWaitListResult ?
                              `Thank you for joining the ${ClubName} membership waitlist, we will be in touch…`
                              :
                              (inWaitList && ClubName) ?
                                expired === 1 ?
                                  `We have been waiting to hear from you. Looks like we sent an invite on
                                          ${moment(InviteSentDate).format('MMM DD, YYYY')}, but we never heard back. Unfortunately this
                                          invitaiton expired on ${moment(InviteSentDate).add(15, 'days').format('MMM DD, YYYY')}.
                                          If you would like to extend your waitlist period please contact us at (888) 202-2006.`
                                  :
                                  InviteSentDate ?
                                    <span>
                                      {iviteSentMessage({ClubName, deletedProfile:IsDisabled})}
                                      <br /><br />
                                      {inviteButtonDisplay({hasClubMembershipInCart, acceptInvitationInProgress, WaitlistId, waitlist, acceptInvitation, IsDisabled})}
                                    </span>
                                    :
                                    `You have been added to the ${waitListClubName} membership waitlist.
                                                   We will notify you when an opening becomes available.`
                                :

                                (inWaitList && waitListClubName === ClubName) ?
                                  `Our records show you already have an active waitlist record for 
                                                ${ClubName}. 
                                                Please contact customer support if you would like to be removed from this waitlist.`
                                  :
                                  waitlist?
                                  `Thanks for showing interest in the ${ClubName} membership. Unfortunately this membership is full at the moment
                                                     but we still have waitlist slots available. Use the "waitlist" button below to be added to the waitlist.`
                                  :
                                  <>
                                    <p className="account-info-block">
                                      It looks like you haven't joined a membership.
                                      Join a membership to receive percentage off of wines and exclusive invites to our best events.
                                    </p>
                                    <p className="account-info-block">
                                      <a href="/wine-club/" className="btn btn-primary">
                                        Join a membership
                                      </a>
                                    </p>
                                  </>               
                          }            
                        </p>
                        {
                          (!joinWaitListResult && !inWaitList && waitlist) &&
                          <p className="account-info-block">
                            <a href="#" className="btn btn-primary" onClick={() => {
                              showModal('VerifyAddressModal')
                            }}>
                              {`${ClubName} waitlist`}
                            </a>
                          </p>
                        }
                      </>
                  }
                </>
              }
            </> :
            <>
              {(user && !validateLoginInProgress && !clubByIdInProgress && !waitListStatusInProgress) ? (
                <>
                  <p className="account-info-block">
                    It looks like you haven't joined a membership.
                    Join a membership to receive percentage off of wines and exclusive invites to our best events.
                  </p>
                  <p className="account-info-block">
                    <a href="/wine-club/" className="btn btn-primary">
                      Join a membership
                    </a>
                  </p>
                </>
              ) :
                <Loading />
              }
            </>
        }
      </div>
    );
  }
}


export default NotActive;
